import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconListDynamic(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M13 3a1 1 0 0 0-1 1v8.221a1 1 0 0 0 1 1h1.087L14 19.986a1 1 0 0 0 1.856.53l6-9.945A1 1 0 0 0 21 9.055h-.967l1.894-4.68A1 1 0 0 0 21 2.998h-8Zm1 8.221V5h5.517l-1.894 4.68a1 1 0 0 0 .927 1.376h.679l-3.182 5.273.053-4.094a1 1 0 0 0-1-1.013H14Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        d="M4 5a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2H4ZM3 10a1 1 0 0 1 1-1h5a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1ZM3 14a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1ZM4 17a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2H4Z"
      />
    </BaseIcon>
  );
}
